import { expeditionsEndpoints } from "./expeditions.api"

export * from "./types"

export const {
  useGetAllExpeditionsQuery,
  useStartExpeditionMutation,
  useGetExpeditionRewardsMutation,
  useFinishExpeditionMutation,
  useGetAttemptsQuery,
  useGetExpeditionProgressQuery,
  endpoints: {
    getAllExpeditions,
    startExpedition,
    getExpeditionRewards,
    finishExpedition,
    getAttempts,
    getExpeditionProgress
  }
} = expeditionsEndpoints
